import { SubCard } from './chunk-UUZOVONF.js';
import { ProtocolIcon } from './chunk-FZCG5QZY.js';
import { LIFI, LIFI_BRIDGE_CALLS, LIFI_COMPONENTS, pickField, decodedOrRaw, pickFrom, LIFI_FIELD_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge } from './chunk-W3XOXPHM.js';
import { Route } from 'lucide-react';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function MinAmount({ value }) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
    /* @__PURE__ */ jsx(ProtocolValue, { value }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: "text-2xs uppercase tracking-wide text-muted-foreground",
        title: "Guaranteed minimum (floor) \u2014 the actual bridged amount is at least this.",
        children: "(min)"
      }
    )
  ] });
}
function swapFacts(swap) {
  const get = (...names) => pickFrom(swap, ...names);
  const fromToken = get("sendingAssetId", "fromAssetId", "fromToken");
  const fromAmount = get("fromAmount", "amountIn", "inputAmount");
  const toToken = get("receivingAssetId", "toAssetId", "toToken");
  const router = get("callTo", "approveTo");
  return [
    { label: LIFI_FIELD_LABELS.fromToken, value: /* @__PURE__ */ jsx(ProtocolValue, { value: fromToken }), when: fromToken },
    { label: LIFI_FIELD_LABELS.fromAmount, value: /* @__PURE__ */ jsx(ProtocolValue, { value: fromAmount }), when: fromAmount != null },
    { label: LIFI_FIELD_LABELS.toToken, value: /* @__PURE__ */ jsx(ProtocolValue, { value: toToken }), when: toToken },
    { label: LIFI_FIELD_LABELS.swapRouter, value: /* @__PURE__ */ jsx(ProtocolValue, { value: router }), when: router }
  ];
}
function LiFiBridge({ call: call2, hint }) {
  const bridge = pickField(call2.params, "bridgeData");
  const swaps = decodedOrRaw(pickField(call2.params, "swapData"));
  const swap = Array.isArray(swaps) ? swaps[0] : void 0;
  const mayan = pickField(call2.params, "mayanData");
  const bget = (...names) => pickFrom(bridge, ...names);
  const bridgedToken = bget("sendingAssetId", "fromAssetId", "fromToken");
  const minAmount = bget("minAmount", "minAmountOut", "amount");
  const recipient = bget("receiver", "receivingAddress", "to", "recipient");
  const destChain = bget("destinationChainId", "destChainId", "toChainId");
  const bridgeName = bget("bridge");
  const transferId = bget("transactionId", "txId", "transferId");
  const mayanProtocol = pickFrom(mayan, "mayanProtocol", "protocol");
  const hasBridge = bridgedToken != null || recipient != null || minAmount != null || destChain != null;
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: LIFI.protocolId, icon: Route }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? call2.label ?? "Bridge via LI.FI" })
  ] });
  const facts = [
    { label: LIFI_FIELD_LABELS.bridgedToken, value: /* @__PURE__ */ jsx(ProtocolValue, { value: bridgedToken }), when: bridgedToken },
    { label: LIFI_FIELD_LABELS.minAmount, value: /* @__PURE__ */ jsx(MinAmount, { value: minAmount }), when: minAmount != null },
    { label: LIFI_FIELD_LABELS.recipient, value: /* @__PURE__ */ jsx(ProtocolValue, { value: recipient }), when: recipient },
    { label: LIFI_FIELD_LABELS.destChain, value: /* @__PURE__ */ jsx(ProtocolValue, { value: destChain }), when: destChain != null },
    { label: LIFI_FIELD_LABELS.bridge, value: /* @__PURE__ */ jsx(ProtocolValue, { value: bridgeName }), when: bridgeName },
    { label: LIFI_FIELD_LABELS.mayanProtocol, value: /* @__PURE__ */ jsx(ProtocolValue, { value: mayanProtocol }), when: mayanProtocol },
    { label: LIFI_FIELD_LABELS.transactionId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: transferId }), when: transferId }
  ];
  const swapFactList = swap != null ? swapFacts(swap) : [];
  return /* @__PURE__ */ jsxs(SectionCard, { title, protocolId: LIFI.protocolId, meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: LIFI.protocolId }), children: [
    hasBridge ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(FactGrid, { facts }),
      swapFactList.length > 0 && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsx(SubCard, { caption: "Source swap", children: /* @__PURE__ */ jsx(FactGrid, { facts: swapFactList }) }) })
    ] }) : (
      // The facet calldata didn't decode into the expected BridgeData — show the
      // generic argument list rather than an empty card.
      /* @__PURE__ */ jsx(ProtocolParamList, { params: call2.params, emptyLabel: "No decoded arguments" })
    ),
    /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
      /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All call arguments" }),
      /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: call2.params, emptyLabel: "No decoded arguments" }) })
    ] })
  ] });
}

// src/protocols/lifi/index.ts
var PID = LIFI.protocolId;
var call = (name) => ({
  protocolId: PID,
  call: name,
  component: LIFI_COMPONENTS.bridge,
  label: "Bridge via LI.FI",
  summaryFields: []
});
var LIFI_HINTS = {
  valueHints: [],
  eventHints: [],
  callHints: LIFI_BRIDGE_CALLS.map(call)
};
function registerLiFi(registry) {
  registry.registerCall(LIFI_COMPONENTS.bridge, LiFiBridge);
  registry.registerHints(LIFI_HINTS);
  return registry;
}

export { LIFI_HINTS, LiFiBridge, registerLiFi };
//# sourceMappingURL=chunk-PFWPLN7D.js.map
//# sourceMappingURL=chunk-PFWPLN7D.js.map